import React from 'react';
import Icon from 'components/Icon';
import styles from './styles.css';

export const Info = ({ children }) => (
  <div className={styles.wrap}>
    <Icon name="circle-info-blue" className={styles.icon} />
    <p className={styles.text}>{children}</p>
  </div>
);
